export default __webpack_public_path__ + "media/zurb/img/events/wired/rcs/rcs-2-42bb9ebbbc9a99876bcd873a295a263b.jpg";